export enum PaymentMethodTypes {
    Card = 'Card',
    Paypal = 'Paypal'
}